<script lang="ts">
    import { Col, ListGroup, ListGroupItem,Image } from "sveltestrap";
    import { Crasjustoodio, Dapibusacfacilisisin, href, Morbileorisus, Vestibulumateros, WithImageRounded} from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    let imgPath:string = "/assets/images/user"
</script>
<Col sm="12" xl="12">
    <Card cardHeaderprops="pb-0" headerTitle={WithImageRounded}>
      <div slot="contentbody">
        <ListGroup>
          <ListGroupItem >
            <Image class="rounded-circle" src="{imgPath}/1.jpg" alt="" />{Crasjustoodio}
          </ListGroupItem>
          <ListGroupItem >
            <Image class="rounded-circle" src="{imgPath}/1.jpg" alt="" />{Dapibusacfacilisisin}
          </ListGroupItem>
          <ListGroupItem >
            <Image class="rounded-circle" src="{imgPath}/1.jpg" alt="" />{Morbileorisus}
          </ListGroupItem>
          <ListGroupItem disabled >
            <Image class="rounded-circle" src="{imgPath}/1.jpg" alt="" />{Vestibulumateros}
          </ListGroupItem>
        </ListGroup>
      </div>
    </Card>
</Col>